import { useEffect, useState, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import axios from "axios";
import Header from "../components/landing/Header";
import HeroSection from "../components/landing/HeroSection";
import ServicesSection from "../components/landing/ServicesSection";
import ProcessSection from "../components/landing/ProcessSection";
import ReferencesSection from "../components/landing/ReferencesSection";
import AboutSection from "../components/landing/AboutSection";
import ContactSection from "../components/landing/ContactSection";
import Footer from "../components/landing/Footer";
import LegalModals from "../components/landing/LegalModals";
import FloatingCircles from "../components/landing/FloatingCircles";
import MobileStickyBar from "../components/landing/MobileStickyBar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LandingPage = () => {
  const [references, setReferences] = useState([]);
  const [showImpressum, setShowImpressum] = useState(false);
  const [showDatenschutz, setShowDatenschutz] = useState(false);
  const containerRef = useRef(null);
  
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end end"]
  });

  useEffect(() => {
    const fetchReferences = async () => {
      try {
        const response = await axios.get(`${API}/references/public`);
        setReferences(response.data);
      } catch (error) {
        console.error("Error fetching references:", error);
      }
    };

    // Seed data on first load
    axios.post(`${API}/seed`).catch(() => {});
    fetchReferences();
  }, []);

  // Set page title and meta
  useEffect(() => {
    document.title = "Komel AG – Total- und Generalunternehmerin in St. Gallen";
    
    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Komel AG in St. Gallen: Total- und Generalunternehmung, Neubau, Sanierung und Renovation. Alles aus einer Hand – vom Keller bis zum Dach.";
  }, []);

  return (
    <div ref={containerRef} className="min-h-screen bg-white relative">
      {/* Floating Orange Circles - Parallax Effect */}
      <FloatingCircles />
      
      <Header scrollProgress={scrollYProgress} />
      
      <main>
        <HeroSection />
        
        <ServicesSection />
        
        <ProcessSection />
        
        <ReferencesSection references={references} />
        
        <AboutSection />
        
        <ContactSection />
      </main>
      
      <Footer 
        onImpressum={() => setShowImpressum(true)}
        onDatenschutz={() => setShowDatenschutz(true)}
      />
      
      <LegalModals
        showImpressum={showImpressum}
        showDatenschutz={showDatenschutz}
        onCloseImpressum={() => setShowImpressum(false)}
        onCloseDatenschutz={() => setShowDatenschutz(false)}
      />
      
      {/* Mobile Sticky Bar */}
      <MobileStickyBar />
    </div>
  );
};

export default LandingPage;
